import { Box, BoxProps, Typography } from '@mui/material';
import { Spinner } from '../Spinner';
import styles from './CopySharableLink.module.scss';
import { Link as LinkIcon } from '../../blocks/icons/Link';
import classNames from 'classnames';
import { Tooltip } from '../Tooltip';

export type CopySharableLinkProps = {
	className?: string;
	onClick: () => void;
	loading?: boolean;
	disabled?: boolean;
	popover?: string;
} & Omit<BoxProps, 'popover'>;

export const CopySharableLink: React.FC<CopySharableLinkProps> = ( {
	className,
	onClick,
	loading,
	disabled,
	popover,
	...props
} ) =>
	popover ? (
		<Tooltip
			target={
				<Box
					onClick={ disabled ? undefined : onClick }
					className={ classNames( styles.container, className, {
						[ styles.disabled ]: disabled,
					} ) }
					{ ...props }
				>
					{ loading ? (
						<Spinner size={ 18 } />
					) : (
						<>
							<Typography className={ styles.text }>
								Copy sharable link
							</Typography>
							<LinkIcon className={ styles.icon } />
						</>
					) }
				</Box>
			}
		>
			{ popover }
		</Tooltip>
	) : (
		<Box
			onClick={ disabled ? undefined : onClick }
			className={ classNames( styles.container, className, {
				[ styles.disabled ]: disabled,
			} ) }
			{ ...props }
		>
			{ loading ? (
				<Spinner size={ 18 } />
			) : (
				<>
					<Typography className={ styles.text }>Copy sharable link</Typography>
					<LinkIcon className={ styles.icon } />
				</>
			) }
		</Box>
	);
